import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ErrorMessage from '../components/ErrorMessage';
import LoadingState from '../components/LoadingState';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { user, loading, signIn, signUp, isSupabaseConfigured, supabaseConfigError } = useAuth();
  const location = useLocation();
  const [mode, setMode] = useState('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const from = location.state?.from?.pathname || '/dashboard';

  if (loading) return <LoadingState />;
  if (user) return <Navigate to={from} replace />;

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      if (mode === 'signin') await signIn(email, password);
      else await signUp(email, password, fullName);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="brand login-brand">
          <div className="brand-mark">KPI</div>
          <div>
            <strong>Operations</strong>
            <span>Dashboard</span>
          </div>
        </div>
        <h1>{mode === 'signin' ? 'Sign in' : 'Create account'}</h1>
        <p>Use your Supabase Auth account to access the dashboard.</p>
        <ErrorMessage message={supabaseConfigError || error} />
        {mode === 'signup' && (
          <label>
            Full name
            <input value={fullName} onChange={(event) => setFullName(event.target.value)} placeholder="Jhunel Bernales" />
          </label>
        )}
        <label>
          Email
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} required minLength={6} />
        </label>
        <button type="submit" className="button primary full" disabled={submitting || !isSupabaseConfigured}>
          {submitting ? 'Please wait...' : mode === 'signin' ? 'Sign in' : 'Sign up'}
        </button>
        <button type="button" className="link-button" onClick={() => setMode(mode === 'signin' ? 'signup' : 'signin')}>
          {mode === 'signin' ? 'Need an account? Sign up' : 'Already have an account? Sign in'}
        </button>
      </form>
    </div>
  );
}
